var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuOverflow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0002 6.25C10.6906 6.25 11.2502 5.69036 11.2502 5C11.2502 4.30964 10.6906 3.75 10.0002 3.75C9.30989 3.75 8.75024 4.30964 8.75024 5C8.75024 5.69036 9.30989 6.25 10.0002 6.25ZM10.0002 11.2495C10.6906 11.2495 11.2502 10.6899 11.2502 9.99951C11.2502 9.30916 10.6906 8.74951 10.0002 8.74951C9.30989 8.74951 8.75024 9.30916 8.75024 9.99951C8.75024 10.6899 9.30989 11.2495 10.0002 11.2495ZM11.2502 15.0005C11.2502 15.6908 10.6906 16.2505 10.0002 16.2505C9.30989 16.2505 8.75024 15.6908 8.75024 15.0005C8.75024 14.3101 9.30989 13.7505 10.0002 13.7505C10.6906 13.7505 11.2502 14.3101 11.2502 15.0005Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuOverflow);
export default __webpack_public_path__ + "static/media/menu-overflow.488593b5144821eb07061d673c47ce2e.svg";
export { ForwardRef as ReactComponent };